var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "pga-bottom-navigation",
        [
          _c(
            "pga-authorized-content",
            { attrs: { permission: "EditBusinessStartupCustomerOrder" } },
            [
              _c("pga-create-button", {
                attrs: { text: "Create External Project" },
                on: {
                  click: function ($event) {
                    return _vm.Navigate("/businessstartup/customerorder/create")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { elevation: "10" } },
        [
          _c(
            "v-card-title",
            { staticClass: "text-center justify-center py-6" },
            [
              _c("h2", { staticClass: "font-weight-bold display-1" }, [
                _vm._v(" Business Startups "),
              ]),
            ]
          ),
          _c(
            "v-tabs",
            { attrs: { "background-color": "transparent", grow: "" } },
            [
              _vm.canReadCutomerOrdersTable
                ? _c("v-tab", [_vm._v(" External Projects ")])
                : _vm._e(),
              _vm.canReadInternalProjectsTable
                ? _c("v-tab", [_vm._v(" Internal Projects ")])
                : _vm._e(),
              _vm.canReadCutomerOrdersTable
                ? _c(
                    "v-tab-item",
                    [_c("pga-business-startup-customer-order-table")],
                    1
                  )
                : _vm._e(),
              _vm.canReadInternalProjectsTable
                ? _c(
                    "v-tab-item",
                    [_c("pga-business-startup-internal-project-table")],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }